import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface BidAmountDisplayProps {
  bidAmount: number;
  isExpired: boolean;
}

export function BidAmountDisplay(props: BidAmountDisplayProps) {
  const { bidAmount, isExpired } = props;

  return (
    <Stack direction="row" alignItems="baseline" spacing={1}>
      <Text variant="h3" color={(theme) => theme.palette.text.secondary}>
        $
      </Text>
      <Text
        variant="h3"
        color={(theme) => (isExpired ? theme.palette.text.secondary : theme.palette.primary?.main)}
      >
        {bidAmount.toFixed(2)}
      </Text>
      <Text variant="body1">/hr</Text>
    </Stack>
  );
}
